<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/O7noHP/tc-custom/9781625841636.jpg?1728259422545" alt="This image is the cover for the book Haunted Boonslick, Haunted America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Haunted Boonslick, Haunted America
      </h1>
      <p class="bookDescription body article font2">
        <b>“A slim, riveting tome dedicated to the haunts of the Mid-Missouri region . . . [This] book is chock-full of history” (<i>Columbia Daily Tribune</i>).</b><br/>  <br/> There is some uncertainty about the exact borders of the region that surrounds the Boonslick Trail but little doubt about the palpable and unsettling presence of its history. Stir up Missourians from St. Louis to Jackson County with the mention of ghosts, and after a few minutes of demurring, you will soon have more stories than you can shake a sheet at. Attend to the haunting music of John “Blind” Boone or the otherworldly poetry of Patience Worth. Crouch down in Civil War battlefields, crowded taverns, or the uncomfortable saddle of a headless horse. Wend your way through Missouri’s haunted heart: the Boonslick.<br/>  <br/> Includes photos!<br/>  <br/> “The book covers a broad history of hauntings and unexplained occurrences since 1812. It is peppered with ghost stories that have very human explanations.” —<i>Missourian</i><br/>  <br/> “Mary Collins Barile gives a history of the area, and mentions that these ghost stories are ones that are unknown to outsiders, yet important to the history of the region.” —<i>St. Louis </i>magazine
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mary Collins Barile
      </h2>
      
      <p class="authorDescription body article">Mary Collins Barile is an adjunct assistant professor at the University of Missouri. She is a board member of the Missouri Center for the Book, the Missouri Parks Association, the Friends of Historic Boonville (where she resides), the MU Libraries Friends, and the Western Writers Association.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Haunted America
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?419b6811